import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "snackbar-container" }

import { computed } from 'vue'
import Snackbar from '@/components/snackbar/Snackbar.vue'
import { SnackbarMessage } from '@/store/application-store'

interface Props {
  messages: SnackbarMessage[]
}
interface Emits {
  (event: 'dismiss', messageId: number): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SnackbarContainer',
  props: {
    messages: null
  },
  emits: ["dismiss"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'dismiss', messageId: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  messages: SnackbarMessage[]
};



// Messages are rendered from bottom to top
const messagesReversed = computed(() => [...props.messages].reverse())




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, {
      name: "snackbar-transition",
      appear: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(messagesReversed), ({ id, state, header, text }) => {
          return (_openBlock(), _createBlock(Snackbar, {
            class: "snackbar-container__item",
            key: id,
            state: state,
            header: header,
            text: text,
            onClick: ($event: any) => (emits('dismiss', id))
          }, null, 8, ["state", "header", "text", "onClick"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})